import { ModelBase } from "@shoothill/core";
import { action, observable } from "mobx";

export class ProjectModel extends ModelBase<ProjectModel, ProjectDTO> {
    // #region Constructors and Disposers
    // #endregion Constructors and Disposers

    // #region Defaults and Constants

    public static readonly DEFAULT_ID = "";
    public static readonly DEFAULT_DISPLAYNAME = "";
    public static readonly DEFAULT_ISSTOCKPROJECT = false;
    public static readonly DEFAULT_ISCENTRALPROJECT = false;

    // #endregion Defaults and Constants

    // #region Observables

    @observable
    public id: string = ProjectModel.DEFAULT_ID;

    @observable
    public displayName: string = ProjectModel.DEFAULT_DISPLAYNAME;

    @observable
    public isStockProject: boolean = ProjectModel.DEFAULT_ISSTOCKPROJECT;

    @observable
    public isCentralProject: boolean = ProjectModel.DEFAULT_ISCENTRALPROJECT;

    // #endregion Observables

    // #region Actions

    @action
    public reset(): void {
        this.id = ProjectModel.DEFAULT_ID;
        this.displayName = ProjectModel.DEFAULT_DISPLAYNAME;
        this.isStockProject = ProjectModel.DEFAULT_ISSTOCKPROJECT;
        this.isCentralProject = ProjectModel.DEFAULT_ISCENTRALPROJECT;
    }

    @action
    public fromDto(dto: ProjectDTO): void {
        this.id = dto.id;
        this.displayName = dto.name;
        this.isStockProject = dto.isStockProject;
        this.isCentralProject = dto.isCentralProject;
    }

    public toDto() {
        throw new Error("Method not implemented.");
    }

    // #endregion Actions

    // #region Helpers

    public static fromDtos(dtos: ProjectDTO[]): ProjectModel[] {
        const types: ProjectModel[] = [];

        for (const dto of dtos) {
            const model = new ProjectModel();

            model.fromDto(dto);
            types.push(model);
        }

        return types;
    }

    // #endregion Helpers
}

export interface ProjectDTO {
    id: string;
    name: string;
    isStockProject: boolean;
    isCentralProject: boolean;
}
